import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgClock = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m.75 6.442a.75.75 0 0 0-1.5 0V12c0 .18.064.352.18.488l3.615 4.213a.75.75 0 0 0 1.139-.977l-3.434-4.002z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgClock;
